import zIndex from '@mui/material/styles/zIndex';
import React from 'react';
import Select from 'react-select';
import { colours } from 'utils/constants';

type OptionsProps = {
  value: string;
  label: string;
};

type SelectInputProps = {
  name: string;
  label: string;
  placeholder: string;
  disabled?: boolean;
  loading?: boolean;
  options?: OptionsProps[];
  wrapperClass?: string;
  Controller: any;
  control: any;
  errors: any;
  defaultValue?: any;
};

export default function SelectInput({
  name,
  label,
  placeholder,
  disabled = false,
  loading = false,
  options,
  wrapperClass,
  Controller,
  control,
  errors,
  defaultValue,
  ...rest
}: SelectInputProps) {
  const customStyles = {
    // This style helps ensure the menu is correctly positioned when using portals
    menuPortal: (base: any) => ({ ...base, zIndex: zIndex.modal }),

    // Customizing the dropdown menu's appearance
    menu: (base: any) => ({
      ...base,
      backgroundColor: colours.selectGrey,
      marginTop: '0.25rem',
      paddingLeft: '10px',
      paddingRight: '10px',
      width: '100%',
      borderRadius: '0.5rem'
    })
  };

  const menuPortalTarget = document.getElementById('root');

  return (
    <div className={`${wrapperClass} flex flex-col items-start pb-4 text-sm`}>
      {label && (
        <label className="text-neutral7 uppercase" htmlFor={name}>
          {label}
        </label>
      )}
      <Controller
        control={control}
        defaultValue={defaultValue}
        name={name}
        {...rest}
        render={({ field: { onChange, value } }: any) => {
          return (
            <Select
              key={`my_unique_select_key__${JSON.stringify(value)}`}
              className="select w-full"
              placeholder={placeholder}
              isDisabled={disabled}
              isLoading={loading}
              isClearable
              isSearchable
              options={options}
              onChange={(opts: any) => onChange(opts?.value)} // Todo: fix needed if selected Multi option
              closeMenuOnSelect
              value={options?.find((opt) => opt.value === value)}
              styles={customStyles}
              menuPortalTarget={menuPortalTarget}
            />
          );
        }}
      />

      {errors[name] && (
        <span className="error" role="alert">
          {errors[name].message}
        </span>
      )}
    </div>
  );
}
